import * as Yup from "yup";

export const resourceObject = {
  resourceID: "",
  payload: "",
  headers: "",
  url: "",
  method: "",
  resourceName: "",
  resourceDescription: "",
  isTokenGenerated: false,
};

export function objectFromFormData(formData) {
  return {
    _id: formData.resourceID,
    resource_name: formData.resourceName,
    description: formData.resourceDescription,
    generated_token: formData.generatedToken,
  };
}

export function objectFromResponseData(responseData) {
  return {
    resourceID: responseData._id,
    resourceName: responseData.resource_name,
    resourceDescription: responseData.description,
    isTokenGenerated: responseData.is_token_generated,
  };
}

export const validationSchema = Yup.object({
  sample_payload: Yup.string().required("Payload is required"),
  headers: Yup.string().required("Headers is required"),
  url: Yup.string().required("Url is required"),
  method: Yup.string().required("Method is required"),
  resourceName: Yup.string().required("Resource Name is required"),
  resourceDescription: Yup.string().required("Description is required"),
  isTokenGenerated: Yup.bool().oneOf([true], "Token not generated"),
});
